import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const VerticalAdviceCardsCCD: IClientComponentDefinition = {
  name: 'verticalAdviceCards',
  load: () => import(/* webpackChunkName: 'verticalAdviceCards' */ './index'),
}
